module.exports = __webpack_public_path__ + "static/img/17.6efe6c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/csfish/17.png
// module id = gToh
// module chunks = 0